import React from 'react';
import PropTypes from 'prop-types';
import { getInboxButtonTitle } from './InboxComponent.js';

export class InboxButtonComponent extends React.Component {
    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired
    }

    render() {
        if (this.props.disabled) {
            return null;
        }
        
        const self = this;
        const onClickCb = this.props.pushCB ? function () {
            self.props.pushCB("inbox;" + self.props.activeId + ";" + self.props.groupType);
        } : null;

        return (
            <div className="item inbox" onClick={onClickCb}>
                <h4>{getInboxButtonTitle(this.context.t, this.context.p, true, this.props.groupType)}</h4>
            </div>
        );
    }
}

InboxButtonComponent.propTypes = {
    groupType: PropTypes.string.isRequired,
    pushCB: PropTypes.func.isRequired,
    activeId: PropTypes.string,
    disabled: PropTypes.bool
};